if (!customElements.get('sc-localization-modal')) {
  customElements.define(
    'sc-localization-modal',
    class ScLocalizationModal extends HTMLElement {
      constructor() {
        super();
        this.openedBy = null;
        this.dialog = this.querySelector('[role="dialog"]');
        this.form = this.querySelector('form');
        this.confirmButton = this.querySelector('[data-sc-loc-confirm]');
        this.countryInput = this.querySelector('input[name="country_code"]');
        this.localeInput = this.querySelector('input[name="locale_code"]');

        this.querySelector('#ModalClose-sc-loc')?.addEventListener('click', () => this.hide());
        this.querySelectorAll('[data-sc-loc-close]').forEach((el) => {
          el.addEventListener('click', () => this.hide());
        });

        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        this.querySelectorAll('[data-sc-loc-option]').forEach((option) => {
          option.addEventListener('click', () => this.selectOption(option));
          option.addEventListener('keydown', (event) => this.onOptionKeyDown(event, option));
        });

        this.form?.addEventListener('submit', (event) => {
          if (!this.countryInput?.value && !this.localeInput?.value) {
            event.preventDefault();
          }
        });
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);

        document.querySelectorAll('[data-sc-loc-open]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.show(trigger);
          });
        });
      }

      show(opener) {
        this.openedBy = opener;
        this.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
        if (this.openedBy) {
          this.openedBy.setAttribute('aria-expanded', 'true');
        }
        trapFocus(this.dialog, this.dialog);
      }

      hide() {
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
        if (this.openedBy) {
          this.openedBy.setAttribute('aria-expanded', 'false');
        }
        removeTrapFocus(this.openedBy);
        this.openedBy = null;
      }

      selectOption(option) {
        const type = option.dataset.scLocOption;
        const list = option.closest('[role="listbox"]');
        if (!list) return;

        list.querySelectorAll('[data-sc-loc-option]').forEach((item) => {
          const isSelected = item === option;
          item.classList.toggle('is-active', isSelected);
          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        if (type === 'country' && this.countryInput) {
          this.countryInput.value = option.dataset.value;
        }

        if (type === 'language' && this.localeInput) {
          this.localeInput.value = option.dataset.value;
          this.updateConfirmLabel(option);
        }
      }

      updateConfirmLabel(languageOption) {
        if (!this.confirmButton || !languageOption) return;
        const label = languageOption.dataset.confirmLabel;
        if (label) this.confirmButton.textContent = label;
      }

      onOptionKeyDown(event, option) {
        const list = option.closest('[role="listbox"]');
        if (!list) return;

        const options = Array.from(list.querySelectorAll('[data-sc-loc-option]'));
        const index = options.indexOf(option);
        let target;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            target = options[index > 0 ? index - 1 : options.length - 1];
            target.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            target = options[index < options.length - 1 ? index + 1 : 0];
            target.focus();
            break;
          case 'ENTER':
          case 'SPACE':
            event.preventDefault();
            this.selectOption(option);
            break;
        }
      }
    }
  );
}
